<div class="status-label" [ngStyle]="{'background-color': bgColor}">
  <span>{{title | uppercase}}</span> 
</div>
